import React from 'react';
import { Flag, CalendarDays, Briefcase, User, GraduationCap, BadgeDollarSign } from 'lucide-react';
import { Card, Field, FieldGrid, StageChip, fmtDate } from './drawerShared';
import { fmtExperience, fmtTri, fmtNotice, fmtQualification, fmtCtc } from '../CandidateProfileFields';
import { ResumeCard } from './DocumentsTab';

const Kpi = ({ icon: Icon, label, value, testId }) => (
  <div className="flex items-center gap-3.5 rounded-xl border border-slate-200 bg-white p-4 shadow-sm" data-testid={testId}>
    <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-blue-50 text-blue-600"><Icon className="h-5 w-5" /></div>
    <div className="min-w-0">
      <p className="text-[11px] font-bold uppercase tracking-[0.06em] text-slate-500">{label}</p>
      <div className="sf-heading mt-0.5 truncate text-base font-bold text-slate-900">{value}</div>
    </div>
  </div>
);

export const OverviewTab = ({ candidate: c, canViewCtc, resumeProps }) => (
  <div className="space-y-5" data-testid="tab-panel-overview">
    <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
      <Kpi icon={Flag} label="Current Stage" value={<StageChip stage={c.stage} className="mt-0.5" />} testId="kpi-stage" />
      <Kpi icon={CalendarDays} label="Applied" value={fmtDate(c.created_at)} testId="kpi-applied" />
      <Kpi icon={Briefcase} label="Job Position" value={<span title={c.job_title}>{c.job_title || c.job_id || '—'}</span>} testId="kpi-job" />
    </div>

    <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
      <Card title="Quick Info" icon={User} data-testid="overview-quick-info">
        <FieldGrid>
          <Field label="Email" value={c.email} />
          <Field label="Phone" value={c.phone} />
          <Field label="Current Location" value={c.current_location} />
          <Field label="Preferred Location" value={c.preferred_location} />
          <Field label="Willing to Relocate" value={fmtTri(c.willing_to_relocate)} muted={c.willing_to_relocate == null} />
          <Field label="Notice Period" value={fmtNotice(c.notice_period_days)} />
          <Field label="Notice Negotiable" value={fmtTri(c.notice_negotiable)} muted={c.notice_negotiable == null} />
        </FieldGrid>
      </Card>

      <div className="space-y-5">
        <Card title="Education & Experience" icon={GraduationCap} data-testid="drawer-education-section">
          <FieldGrid>
            <Field label="Highest Qualification" value={fmtQualification(c.highest_qualification, c.qualification_detail)} full />
            <Field label="Relevant Experience" value={fmtExperience(c.relevant_experience)} />
            <Field label="Total Experience" value={fmtExperience(c.total_experience)} />
          </FieldGrid>
        </Card>

        <Card title={canViewCtc ? 'Compensation & Availability' : 'Availability'} icon={BadgeDollarSign} data-testid="drawer-compensation-section">
          <FieldGrid>
            <Field label="Notice Period" value={fmtNotice(c.notice_period_days)} />
            <Field label="Notice Negotiable" value={fmtTri(c.notice_negotiable)} muted={c.notice_negotiable == null} />
            {canViewCtc && (
              <>
                <Field label="Current CTC" value={fmtCtc(c.current_ctc)} testId="drawer-ctc-block" />
                <Field label="Expected CTC" value={fmtCtc(c.expected_ctc)} />
                <Field label="CTC Negotiable" value={fmtTri(c.ctc_negotiable)} muted={c.ctc_negotiable == null} />
              </>
            )}
          </FieldGrid>
        </Card>
      </div>
    </div>

    <ResumeCard {...resumeProps} compact={false} testId="overview-resume-card" />
  </div>
);
